module.exports = __webpack_public_path__ + "static/media/Icons_CA-01.569ae8a7.svg";